import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default function ListView({
    title,
    url,
    thumb,
    price,
    properties,
}) {
    const Price = ComponentRegistry.get("Price");
    const Image = ComponentRegistry.get("Image");

    const incentives = Object.values(properties.incentives.value)
        .map(incentive => <span key={incentive.id}>{incentive.title}</span>);

    return (
      <article className="item col col-12 bp-tablet-col-12 bp-phone-col-1" itemType="http://schema.org/Product">
        <a href={url}>
          <div className="image group col col-1">
            <Image src={thumb} alt={title} />
          </div>
          <div className="col col-6">
            <h2 itemProp="name">{title}</h2>
            <div className="btn-group">
              {incentives}
            </div>
          </div>
          <div className="col col-2">
            <Price value={price.excl} />
          </div>
        </a>
      </article>
    );
}

ListView.propTypes = {
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    thumb: PropTypes.string.isRequired,
    price: PropTypes.shape({
        excl: PropTypes.string.isRequired,
    }).isRequired,
    properties: PropTypes.shape({
        incentives: PropTypes.shape({}).isRequired,
    }).isRequired,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductBrowser/Views/ListView.jsx